import { getDaysInMonth, getFirstDayOfMonth } from './helpers'

// Generate calendar days array
export function generateCalendarDays(
  currentMonth: number,
  currentYear: number
): (number | null)[] {
  const daysInMonth = getDaysInMonth(currentMonth, currentYear)
  const firstDay = getFirstDayOfMonth(currentMonth, currentYear)
  const days: (number | null)[] = []

  // Пустые ячейки для дней предыдущего месяца
  for (let i = 0; i < firstDay; i++) {
    days.push(null)
  }

  // Дни текущего месяца
  for (let day = 1; day <= daysInMonth; day++) {
    days.push(day)
  }

  // Дни следующего месяца для заполнения сетки
  const totalCells = 42 // 6 недель * 7 дней
  const remainingCells = totalCells - days.length
  for (let i = 0; i < remainingCells; i++) {
    days.push(null)
  }

  return days
}

// Check if day is today
export function isToday(
  day: number | null,
  currentMonth: number,
  currentYear: number
): boolean {
  if (day === null) return false
  const today = new Date()
  return (
    day === today.getDate() &&
    currentMonth === today.getMonth() &&
    currentYear === today.getFullYear()
  )
}

// Check if day is selected
export function isSelected(
  day: number | null,
  selectedDate: Date | null,
  currentMonth: number,
  currentYear: number
): boolean {
  if (day === null || !selectedDate) return false
  return (
    day === selectedDate.getDate() &&
    currentMonth === selectedDate.getMonth() &&
    currentYear === selectedDate.getFullYear()
  )
}
